import { Environments } from '@/config';
import { HELIX_PARKVIEW_PRODUCTION } from './helix-parkview.production';
import { HELIX_PARKVIEW_STAGING } from './helix-parkview.staging';

export const HELIX_PARKVIEW =
  import.meta.env.MODE === Environments.PROD ? HELIX_PARKVIEW_PRODUCTION : HELIX_PARKVIEW_STAGING;
